import { memo } from 'react';

import { useFlag } from '../../services/launchDarkly';

import { FooterNavigation } from './FooterNavigation/FooterNavigation';
import OldDesignFooterNav from './OldDesignFooterNav';

const FooterNav = memo(() => {
  const newDesign = useFlag('ui_redesign_navigation_bar', true);

  if (!newDesign) {
    return <OldDesignFooterNav />;
  }
  return <FooterNavigation />;
});

FooterNav.displayName = 'FooterNav';

export default FooterNav;
